import { AxiosResponse } from "axios";
import { SubjectEntity, SubjectEntityInput } from "./subjects.types";
import { api } from "../api";

export const getSubjects = async () => {
  try {
    const response: AxiosResponse<SubjectEntity[]> = await api.get("/subjects");
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getSubjectById = async (id: number) => {
  try {
    const response: AxiosResponse<SubjectEntity> = await api.get(
      "/subjects/" + id
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const createSubject = async (data: SubjectEntityInput) => {
  try {
    const response: AxiosResponse<SubjectEntity> = await api.post(
      "/subjects",
      data
    );

    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateSubject = async (id: number, data: SubjectEntityInput) => {
  try {
    const response: AxiosResponse<SubjectEntity> = await api.patch(
      "/subjects/" + id,
      data
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const deleteSubject = async (id: number) => {
  try {
    const response: AxiosResponse<SubjectEntity> = await api.delete(
      "/subjects/" + id
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
